import { Languages } from './languages'
import { IncludedApiMessages, translatedApiMessages } from './messages/api'
import { IncludedChangelogMessages, translatedChangelogMessages } from './messages/changelog'
import { IncludedIntroMessages, translatedIntroMessages } from './messages/intro'
import { IncludedLabelMessages, translatedLabelMessages } from './messages/label'
import { IncludedMaskinportenMessages, translatedMaskinportenMessages } from './messages/maskinporten'

export const allTranslations: IncludedApiMessages &
  IncludedIntroMessages &
  IncludedLabelMessages &
  IncludedMaskinportenMessages &
  IncludedChangelogMessages = {
    ...translatedApiMessages,
    ...translatedIntroMessages,
    ...translatedLabelMessages,
    ...translatedMaskinportenMessages,
    ...translatedChangelogMessages
  }

export const translationsToJson = (lan: Languages): Object => {
  const translatedKeys = {}
  // @ts-ignore
  Object.keys(allTranslations).map((e) => (translatedKeys[e] = allTranslations[e][lan]))
  return translatedKeys
}
